import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {BrandHubPageService_GetTreeNavigationLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/brand_hub/v1/service.grpc.lazy';
import {useIsMultiBrand} from '@aboutyou/router';
import {useFullSession} from '@aboutyou/user';
import {useAppliedPotentialFilters} from '../../../../features/ProductStream/utils';
import {useReductionsStateRequestParameter} from '../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';
import {
  useBrandShopCacheKeyTransformer,
  useBrandShopIdentifier,
} from '../../utils/useBrandShopIdentifier';
import {useCategoryIdentifier} from '../../utils/useCategoryIdentifier';

export const useBrandShopNavigationTree = () => {
  const brandIdentifier = useBrandShopIdentifier();
  const targetGroupIdentifier = useTargetGroupIdentifier();
  const categoryIdentifier = useCategoryIdentifier();
  const appliedFilters = useAppliedPotentialFilters();
  const isMultiBrand = useIsMultiBrand();
  const brandShopCacheKeyTransformer = useBrandShopCacheKeyTransformer();
  const fullSession = useFullSession();

  return useGrpcRequest(
    BrandHubPageService_GetTreeNavigationLazy,
    {
      brand: {
        identifier: brandIdentifier,
      },
      category: categoryIdentifier || null,
      targetGroup: targetGroupIdentifier,
      appliedFilters: {
        filters: appliedFilters,
      },
      isMultiBrand,
      reductionsState: useReductionsStateRequestParameter(),
      session: fullSession,
    },
    {
      keepPreviousData: true,
      transformCacheKey: brandShopCacheKeyTransformer,
    },
  );
};
